import { renderMoment } from '@utils/timeUtils'
import { sourceLabel, freebetTag, clipId } from './transactionLabels'

// Player freebets (+ echoed page/pageSize) -> render-ready view model.
export const toFreebetsView = (data, { renderValue, formatDate }) => {
  const pageSize = data?.pageSize ?? 10

  return {
    activeCount: data?.activeFreebetscount ?? 0,
    page: data?.page ?? 1,
    pageSize,
    rows: (data?.userFreebets ?? []).map((fb) => {
      // Split expiry into date + time (local), same as the bets mapper, so the
      // menu row can stack them like "My Transactions".
      const expiring = fb.expiringAt
        ? renderMoment({
            formatType: 'DD MMM YYYY',
            utcDateString: fb.expiringAt,
            options: { seconds: false, hourFormat: '24', displayMode: 'LOCAL' },
          })
        : null

      // Fully render-ready view model — cards render these directly, no logic.
      const tag = freebetTag({ id: fb.playerFreebetId, source: fb.source })
      return {
        id: fb.id,
        playerFreebetId: fb.playerFreebetId,
        amount: renderValue(fb.freeBetBetAmount), // formatted string, for display
        rawAmount: Number(fb.freeBetBetAmount) || 0, // numeric, for placing the bet
        awarded: fb.numberOfFreeBetsToAward ?? 0,
        used: fb.numberOfFreeBetsUsed ?? 0,
        remaining: (fb.numberOfFreeBetsToAward ?? 0) - (fb.numberOfFreeBetsUsed ?? 0),
        winAmount: renderValue(fb.winAmount),
        status: fb.status,
        source: fb.source,
        sourceText: sourceLabel(fb.source), // "Custom" / "Rain" …
        tag, // full freebet tag (tooltip)
        tagShort: clipId(tag), // clipped for display
        currency: fb.currency,
        jackpotRatio: fb.jackpotRatio,
        packageId: fb.packageId,
        createdAt: formatDate(fb.createdAt),
        claimedAt: formatDate(fb.claimedAt),
        expiringAt: formatDate(fb.expiringAt), // formatted single string (legacy)
        expiringDate: expiring?.date ?? '', // "10 JUL 2026"
        expiringTime: expiring?.time ?? '', // "00:00"
        rawExpiringAt: fb.expiringAt, // raw timestamp, for the live countdown
      }
    }),
  }
}

// Freebets count grouped by status -> render-ready view model.
export const toFreebetsCountView = (data) => ({
  activeCount: data?.activeFreebetscount ?? 0,
  status: data?.status ?? null,
})
